



































import {Component, Prop, Vue} from 'vue-property-decorator';
import {konsole} from '@/services/Konsole';
import {IOption} from '@/models/Option';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faPlus, faMinus, faCheck} from '@fortawesome/pro-solid-svg-icons';

@Component({
  components: {},
})
export default class VehicleOptions extends Vue {
  @Prop() public options: IOption;
  public isOpen: boolean = true;
  constructor() {
    super();
    library.add(faPlus, faMinus, faCheck);  
    // konsole.init('New instance of VehicleOptions');
  }
  get sortedArray(): any{
      function compare(a:any, b:any) {
        if (a.description.toLowerCase() < b.description.toLowerCase())
          return -1;
        if (a.description.toLowerCase() > b.description.toLowerCase())
          return 1;
        return 0;
      }
      return Object(this.options).sort(compare);
    }
}
